/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const GLOBAL_ERROR_MODAL_CONSTANTS = {
  DEFAULT_DESTINATION: '',
  ASSISTED_AUTHENTICATED_DESTINATION: '/account-landing',
  IS_DEBUG_MODE_ON: 'isDebugModeOn',
};

export const GLOBAL_ERROR_EXCEPTION_CODE = {
  CHANGE_PLAN_CONFLICT_ERROR: 'BIZ_0001_INVALID_TRANS_TYPE',
};
